import { DecimalLocalizator } from "sb-helpers";
export class StaticDecimalLocalizator {
    static initialize(oddFormatters, pointFormatter) {
        this._localizator = new DecimalLocalizator({
            oddFormatters,
            pointFormatter
        });
    }
    static getInstance() {
        return this._localizator;
    }
    static dispose() {
        this._localizator = undefined;
    }
}
StaticDecimalLocalizator._localizator = undefined;
StaticDecimalLocalizator._siteDecimalSeparator = undefined;
//# sourceMappingURL=StaticDecimalLocalizator.js.map